module.exports = __webpack_public_path__ + "img/sewer-icon.acd3e185.svg";